import AuthLayout from "../../../layout/AuthLayout.jsx";
import AuthImage from "../../../mosaic/images/auth-image.jpg";
import {useLocation, useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {useOnboardingRoutes} from "../../../Routing.jsx";


export default function OnBoardingLayout({children, above, title}) {
    let {t} = useTranslation();
    let [onboardingRoutes] = useOnboardingRoutes();

    let navigate = useNavigate();

    let location = useLocation();

    let step = 1;
    let route = null;

    for (let onBoardingRouteIndex in onboardingRoutes) {
        if (location.pathname === onboardingRoutes[onBoardingRouteIndex].path) {
            route = onboardingRoutes[onBoardingRouteIndex];
            step = onBoardingRouteIndex + 1;
        }
    }

    return (<AuthLayout
        title={title ?? route.name}
        authImage={AuthImage}
        above={<span>{above ?? null}</span>}
    >
        {children}
    </AuthLayout>);

}
